<script setup>
  import { ref, onMounted } from 'vue';
  import FormCountry from '~/components/form/FormCountry.vue';
  import FormState from '~/components/form/FormState.vue';

  const props = defineProps({
    country: {
      type: String,
      required: false,
      default: '',
    },
    state: {
      type: String,
      required: false,
      default: '',
    },
  });

  const internalCountry = ref('');
  const internalState = ref('');
  const isEditingCountry = ref(false);
  const isEditingState = ref(false);

  async function toggleCountryEdit() {
    if (isEditingCountry.value) {
      try {
        const response = await axios.post('/user/update/userinfo', {
          fieldname: 'country',
          value: internalCountry.value,
        });
      } catch (err) {
        // TODO: HANDLE THE ERROR!!!!!!
      }
    }

    isEditingCountry.value = !isEditingCountry.value;
  }
  async function toggleStateEdit() {
    if (isEditingState.value) {
      try {
        const response = await axios.post('/user/update/userinfo', {
          fieldname: 'state',
          value: internalState.value,
        });
      } catch (err) {
        // TODO: HANDLE THE ERROR!!!!!!
      }
    }

    isEditingState.value = !isEditingState.value;
  }

  onMounted(() => {
    internalCountry.value = props.country;
    internalState.value = props.state;
  });
</script>

<template>
  <li class="detail-container">
    <label class="detail-container__label">Country</label>
    <FormCountry
      v-if="isEditingCountry"
      v-model="internalCountry"
      id="customer-information-country"
      name="customer-information-country"
      required
      no-error
      autocomplete="customer country"
    />
    <span v-else>
      {{ internalCountry }}
    </span>
    <span class="detail-container__button">
      <a class="vue-anchor" @click="toggleCountryEdit()">
        <span class="icon-edit" />
        Edit
      </a>
    </span>
  </li>
  <li class="detail-container">
    <label class="detail-container__label">State / Region</label>
    <FormState
      v-if="isEditingState"
      v-model="internalState"
      id="customer-information-state"
      name="customer-information-state"
      required
      no-error
      autocomplete="customer address-level1"
      :country="internalCountry"
    />
    <span v-else>
      {{ internalState }}
    </span>
    <span class="detail-container__button">
      <a class="vue-anchor" @click="toggleStateEdit()">
        <span class="icon-edit" />
        Edit
      </a>
    </span>
  </li>
</template>

<style lang="scss" scoped>
  .detail-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap !important;

    &__label {
      flex: 0 0 30%;
      margin-bottom: 0;
      color: var(--itr-blue);
    }
    &__button {
      flex: 0 0 20%;
      margin-left: auto;
      text-align: right;
      transition: all 0.33s;
    }
  }

  :deep(.base-select-dropdown__list-item) {
    padding: 5px 15px !important;

    span,
    span:first-child,
    span:last-child {
      text-align: left !important;
      flex: none !important;
      padding: 0 !important;
      margin-left: 0 !important;
    }
  }
</style>
